module.exports = __webpack_public_path__ + "static/media/bg-header-landing.10a110c5.png";